const { generateDeviceId } = require('./utilitys.js')

const defaultSettings = {
    cameraSettings: {
        isNightVision: false,
        isAutoLowLight: false,
        isPersonDetection: false,
        isRecording: false,

        enableDetection: false,
        detectionMode: 'motion',
        sensitivity: 2,

        isPreview: false,
        isAudio: false,
        isGrantedMicrophonePermission: false,
        isGrantedCameraPermission: false,
        selectedCamera: null,
        selectedMicrophone: null,

        videoRatio: false,
        isRelay: false,

        isLived: false,

        //////// deviceContext
        idToken: '',
        // refreshToken: '',
        email: '',
        owner: {
            name: '',
            fname: '',
            lname: '',
            picture: '',
            lang: '',
        },
        auth: null,
        newLogin: true,
    },
    deviceSettings: {
        isFirstSignIn: true,
        deviceId: null,
        groupId: null,
        total_connection_count: 0,
        total_connection_duration: 0,
        zoomInLock: false,
    },
    officialWebsiteSettings: {
        auth: null,
    },
}

export default class LocalStorageManager {
    static instance: LocalStorageManager
    static getInstance() {
        if (!this.instance) {
            this.instance = new LocalStorageManager()
        }
        return this.instance
    }

    constructor() {
        this.cameraSettings = this.getSettingsCache('camera')
        this.deviceSettings = this.getSettingsCache('device')

        if (!this.deviceSettings.groupId) {
            this.deviceSettings = {
                ...this.deviceSettings,
                groupId: this.randomGenerateGruopId(),
            }
            this.setSettingsCache({
                type: 'device',
                updateObj: this.deviceSettings,
            })
        }
        if (!this.deviceSettings.deviceId) {
            this.deviceSettings = {
                ...this.deviceSettings,
                deviceId: generateDeviceId(),
            }
            this.setSettingsCache({
                type: 'device',
                updateObj: this.deviceSettings,
            })
        }
    }

    setSettingsCache({ type, updateObj }) {
        const { storageKey, stateKey } = this.getKeyNameByType(type)

        // remove specify key and deep copy
        let update = { ...updateObj }
        update = JSON.parse(JSON.stringify(update))

        update = {
            ...this[stateKey],
            ...update,
        }

        localStorage.setItem(storageKey, JSON.stringify(update))
        this[stateKey] = update
    }

    getSettingsCache(type) {
        const { storageKey, stateKey } = this.getKeyNameByType(type)

        let content = localStorage.getItem(storageKey)
        if (!content) {
            return JSON.parse(JSON.stringify(defaultSettings[stateKey]))
        }

        try {
            content = JSON.parse(content)
            return content
        } catch (error) {
            localStorage.removeItem(storageKey)
            return null
        }
    }

    getAuth() {
        const cache = this.getSettingsCache('camera')
        return cache.auth
    }

    setAuth(jid, refreshToken, kvToken, expireAt, uid, firebaseUid) {
        const auth = {
            jid,
            refreshToken,
            kvToken,
            expireAt,
            uid,
            firebaseUid,
        }
        this.setSettingsCache({ type: 'camera', updateObj: { auth } })
    }

    clear(type) {
        const { storageKey, stateKey } = this.getKeyNameByType(type)
        localStorage.removeItem(storageKey)
        this[stateKey] = JSON.parse(JSON.stringify(defaultSettings[stateKey]))
    }

    getKeyNameByType(type) {
        let storageKey = 'ALFRED_WEBCAMERA_DEVICE_SETTINGS'
        let stateKey = 'deviceSettings'
        switch (type) {
            case 'camera':
                storageKey = 'ALFRED_WEBCAMERA_CAMERA_SETTINGS'
                stateKey = 'cameraSettings'
                break
            case 'officialWebsite':
                storageKey = 'ALFRED_OFFICIAL_WEBSITE_SETTINGS'
                stateKey = 'officialWebsiteSettings'
                break
            default:
        }
        return {
            storageKey,
            stateKey,
        }
    }

    // 0-f
    randomGenerateGruopId() {
        return Math.ceil(Math.random() * 15).toString(16)
    }

    setAmplitudeEventRecord(updateValue) {
        const amplitudeEventRecord = JSON.parse(
            localStorage.getItem('amplitudeEventRecord')
        )
        const newValue = {
            ...amplitudeEventRecord,
            ...updateValue,
        }

        localStorage.setItem('amplitudeEventRecord', JSON.stringify(newValue))
    }

    getAmplitudeEventRecord(key) {
        try {
            const amplitudeEventRecord = JSON.parse(
                localStorage.getItem('amplitudeEventRecord')
            )
            return amplitudeEventRecord[key]
        } catch (error) {
            return null
        }
    }

    clearAmplitudeEventKey() {
        localStorage.removeItem('amplitudeEventRecord')
    }
}
